/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
import React from "react";
import { LinkBase } from "@quintype/components";
import PropTypes from "prop-types";
import { getTextColor, generateNavigateSlug } from "../../../utils/utils";
import "./load-more.m.css";

export const LoadmoreButton = ({
  config = {},
  collection,
  template = "SubsequentLoadCount",
  onClick,
  navigate,
  qtConfig
}) => {
  const { showButton = true, buttonText = "Read More", theme = "", customUrlPath = "" } = config;
  const textColor = getTextColor(theme);

  const slug = generateNavigateSlug(collection, qtConfig, customUrlPath);

  if (!showButton) return null;

  return template === "SubsequentLoadCount" ? (
    <div className="arr--button" styleName={`button ${textColor} default`} onClick={onClick}>
      {buttonText}
    </div>
  ) : (
    <LinkBase href={slug} navigateTo={navigate}>
      <div className="arr--button" styleName={`button ${textColor} default`}>
        {buttonText}
      </div>
    </LinkBase>
  );
};

LoadmoreButton.propTypes = {
  collection: PropTypes.object,
  template: PropTypes.string,
  config: PropTypes.object,
  onClick: PropTypes.func,
  navigate: PropTypes.func,
  qtConfig: PropTypes.object
};
